import PropTypes from 'prop-types';
import React from 'react';
import { UX2 } from '@wsb/guac-widget-core';

const ErrorMessage = ({ message }) => {
  if (!message) return null;
  return <UX2.Element.Text children={ message } style={{ textAlign: 'center' }} />;
};

ErrorMessage.propTypes = {
  message: PropTypes.string
};

export default ErrorMessage;
